import { Award, Film, Sparkles } from "lucide-react";
import { motion } from "framer-motion";

const ambassador = {
  label: "Амбассадор",
  name: "Утекешова Меруерт Каратаевна",
  image: "/images/team/meruert2.jpeg",
  description:
    "Известная советская и казахстанская актриса кино и театра, исполнительница роли Кыз - Жибек. Народная артистка Казахстана.",
};

export default function AmbassadorCard({ light = false, animate = true }) {
  const content = (
    <div
      className={`relative overflow-hidden rounded-2xl border p-6 md:p-8 ${
        light
          ? "border-white/15 bg-white/10 text-white shadow-2xl shadow-primary-950/20"
          : "border-primary-100 bg-white text-dark-900 shadow-card"
      }`}
    >
      <div className="absolute right-0 top-0 h-32 w-32 rounded-bl-[4rem] bg-gradient-to-br from-primary-400/20 to-teal-400/20" />
      <div className="absolute bottom-0 left-0 h-px w-full bg-gradient-to-r from-transparent via-primary-400/60 to-transparent" />

      <div className="relative grid gap-6 lg:grid-cols-[220px_1fr] lg:items-center">
        <div className="relative mx-auto w-full max-w-[240px] lg:mx-0">
          <div className="absolute -inset-2 rounded-[1.75rem] bg-gradient-to-br from-primary-400/30 via-teal-400/20 to-transparent blur-lg" />
          <div className="relative aspect-[4/5] overflow-hidden rounded-[1.5rem] border border-white/40 bg-dark-100 shadow-xl">
            <img
              src={ambassador.image}
              alt={ambassador.name}
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-dark-950/80 via-dark-900/20 to-transparent p-4">
              <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-semibold text-white backdrop-blur-md">
                <Award className="h-3.5 w-3.5" />
                {ambassador.label}
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-5">
          <div>
            <p
              className={`mb-2 inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wider ${
                light
                  ? "bg-white/10 text-primary-100"
                  : "bg-primary-50 text-primary-700"
              }`}
            >
              <Sparkles className="h-3.5 w-3.5" />
              {ambassador.label}
            </p>
            <h3 className="text-2xl font-bold md:text-3xl">{ambassador.name}</h3>
            <p
              className={`mt-3 max-w-3xl text-base leading-relaxed md:text-lg ${
                light ? "text-white/80" : "text-dark-600"
              }`}
            >
              {ambassador.description}
            </p>
          </div>

          <div
            className={`inline-flex w-fit items-center gap-2 rounded-xl px-4 py-3 text-sm font-semibold ${
              light
                ? "bg-white/10 text-white"
                : "bg-gradient-to-r from-primary-50 to-teal-50 text-primary-700"
            }`}
          >
            <Film className="h-4 w-4" />
            Кыз - Жибек
          </div>
        </div>
      </div>
    </div>
  );

  if (!animate) {
    return content;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.5 }}
    >
      {content}
    </motion.div>
  );
}
